import { of, empty } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ofType } from "redux-observable";
import { ofHubEvent, hubEmit } from "@services/hub";
import { sessionError } from "@dux/session";

import appConfig from "@/appConfig";

export const HUB_CONNECT = "pss/hub/CONNECT";
export const HUB_DISCONNECT = "pss/hub/DISCONNECT";
export const HUB_RECONNECT = "pss/hub/RECONNECT";
export const HUB_EVENT = "pss/hub/EVENT";
export const HUB_COMMAND = "pss/hub/COMMAND";

export function hubConnect() {
  return { type: HUB_CONNECT };
}

export function hubDisconnect() {
  return { type: HUB_DISCONNECT };
}

export function hubReconnect() {
  return { type: HUB_RECONNECT };
}

export function hubEvent(id, data) {
  return { type: HUB_EVENT, payload: { id, data } };
}

export function hubInvokeCommand(command, data, callback) {
  return { type: HUB_COMMAND, payload: { command, data, callback } };
}

function hubEpic(action$) {
  return action$.pipe(
    ofHubEvent("ForceLogout"),
    switchMap(() => {
      window.location.href = appConfig.logoutUrl;
      return empty();
    })
  );
}

function hubDisconnectEpic(action$) {
  return action$.pipe(
    ofHubEvent(HUB_DISCONNECT),
    switchMap(() => {
      // todo: do we need this?
      console.log("disconnecting in hub epic");
      return of(
        sessionError({
          isPssError: true,
          data: {},
          errorKey: null,
          localKey: "::PSS::RequestErrorConnection",
          _name: "RequestErrorConnection",
        })
      );
    })
  );
}

function hubEmitterEpic(action$) {
  return action$.pipe(
    ofType(HUB_EVENT),
    switchMap(({ payload }) => {
      let parts = payload.id.split(".");
      if (parts.length > 1) {
        hubEmit(parts[0], payload);
      }

      return empty();
    })
  );
}

export const hubEpics = [hubEpic, hubDisconnectEpic, hubEmitterEpic];
